import { useState } from 'react';

import { getEdf } from 'apis/hcp/edfexports.api';
import { fetchFile } from 'apis/hcp/files.api';

const useGetEdf = (ids: string[]) => {
  const [edfLoading, setEDFLoading] = useState(false);
  const downloadEdf = async () => {
    try {
      setEDFLoading(true);
      const edfResponse = await Promise.all(
        ids.map(async (id: string) => {
          try {
            const response = await getEdf(id);
            return response.data.edfExport.file;
          } catch (e) {
            return null;
          }
        })
      );
      const fileIds = edfResponse.filter((el) => el);
      const fileResponse = await Promise.all(
        fileIds.map(async (id: string) => {
          try {
            const response = await fetchFile(id);
            return response.data.file_url;
          } catch (e) {
            return null;
          }
        })
      );
      setEDFLoading(false);
      fileResponse.forEach((el) => window.open(el));
      return true;
    } catch (e) {
      setEDFLoading(false);
      return false;
    }
  };
  return { downloadEdf, edfLoading };
};

export default useGetEdf;
